import { Suspense } from 'react';

import { PageLoading } from '@/v1/main/views/Result';

import { ErrorElement } from './Error';

export const PageElement = (children: React.ReactNode) => {
    return {
        errorElement: ErrorElement,
        element: <Suspense fallback={<PageLoading />}>{children}</Suspense>,
    };
};
